import React from 'react';
import Avatar from 'material-ui/Avatar'
import Menu, {MenuItem} from 'material-ui/Menu';


class UserInfo extends React.Component {

    state = {
        anchorEl: null,
        open: false,
    };

    handleClick = event => {
        this.setState({open: true, anchorEl: event.currentTarget});
    };

    handleRequestClose = () => {
        this.setState({open: false});
    };

    handleLogout = () => {
      this.props.onLogout();
      this.handleRequestClose();
    };

    render() {
        return (
            <div className="user-profile d-flex flex-row align-items-center">
                <Avatar
                    alt='...'
                    src='./assets/images/no-avatar.png'
                    className="user-avatar "
                />
                <div className="user-detail">
                    <h4 className="user-name" onClick={this.handleClick}>{this.props.user ? this.props.user.name : ''} <i
                        className="zmdi zmdi-caret-down zmdi-hc-fw align-middle"/>
                    </h4>
                    {this.props.client ? this.props.client.name : ''}
                </div>
                <Menu className="user-info"
                      id="simple-menu"
                      anchorEl={this.state.anchorEl}
                      open={this.state.open}
                      onClose={this.handleRequestClose}
                      PaperProps={{
                          style: {
                              width: 120,
                              paddingTop: 0,
                              paddingBottom: 0
                          }
                      }}
                >
                    <MenuItem onClick={this.handleLogout}><i
                        className="zmdi zmdi-sign-in zmdi-hc-fw mr-2"/>Logout
                    </MenuItem>
                </Menu>
            </div>
        );
    }
}

export default UserInfo;




// WEBPACK FOOTER //
// ./components/UserInfo/index.js